// Generated by ts-to-zod
import { z } from 'zod';
import { emailTemplatePayloadBaseSchema } from '../models/emailTemplate.schema';

export const emailTemplatePatchPayloadSchema = emailTemplatePayloadBaseSchema.partial();
